export const faqSchema = `{
      "@context": "http://schema.org/",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Хочу купить билет для ребёнка. Сколько стоит детский ж/д билет на поезд?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Дети до 7 лет путешествуют на поезде бесплатно без предоставления отдельного места. Если детей до 7 лет двое или более, необходимо купить детский билет.  Для детей от 7 до 15 лет действует скидка в размере 50% от цены взрослого билета.  Для покупки детского билета понадобится свидетельство о рождении, удостоверяющее личность ребёнка. Если ребёнок едет не с родителями, нужно оформить доверенность на сопровождение."
          }
        },
        {
          "@type": "Question",
          "name": "Я хочу забронировать билет на поезд. Сколько времени действует бронь?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Бронь на ж/д билет действует 30 минут. 15 минут на ввод данных пассажира и 15 минут на оплату.  После этого нужно заново забронировать билет."
          }
        },
        {
          "@type": "Question",
          "name": "На что обратить внимание при выборе ж/д билета?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Рекомендуем обратить внимание на несколько важных моментов при бронировании ж/д билетов:  · Тип вагона: плацкарт, купе  От выбранного типа зависит стоимость билета и уровень комфорта во время поездки;  · Выбор места.  Вы можете выбрать любое место в вагоне. В плацкартных вагонах места у туалета с 33 до 38 номера, а в купейных -- с 33 по 36. Во всех поездах нижние полки -- это нечетные места, а верхние -- четные."
          }
        },
        {
          "@type": "Question",
          "name": "Я сделал ошибку в личных данных при покупке ж/д билета. Что делать?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Если вы допустили ошибку в билете на поезд, сделайте возврат билета c главной страницы Bile-Bile → Возврат билета и оформите новый."
          }
        },
        {
          "@type": "Question",
          "name": "Какое максимальное количество билетов я могу приобрести в рамках оформления заказа?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "В рамках оформления заказа допускается приобретение 12 билетов. При необходимости увеличения количества билетов, необходимо оформить новый заказ"
          }
        },
        {
          "@type": "Question",
          "name": "Какое подтверждение я получу после оплаты ж/д билета?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": " Подтверждением заказа служит электронный билет, который вы получите после оплаты брони.  Мы также отправим билет на электронную почту или посредством SMS на реквизиты указанные при заказе билета  Электронный билет всегда доступен с главной страницы Bile-Bile → Печать билета и оформите новый"
          }
        },
        {
          "@type": "Question",
          "name": "Необходимо ли иметь при себе билет при посадке в поезд?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "На наши поезда осуществляется посадка пассажира без необходимости предъявления билета (для резидентов РК по бар-коду удостоверения личности, на которое оформлялся заказ билета)"
          }
        },
        {
          "@type": "Question",
          "name": "Я сделал возврат ж/д билета, купленного на Bile-Bile. Когда мне вернут деньги?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Возврат платежей по Билетам, приобретенным по платежным картам, производится на банковский карт-счет, с которого производилась оплата, в течение 5 (пяти) рабочих дней с момента получения подтверждения возврата билета."
          }
        },
        {
          "@type": "Question",
          "name": "Как мне вернуть билет, если его за меня купил кто-то другой?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Возврат билета оформляется c главной страницы Bile-Bile → Возврат билета, по реквизитам оформителя."
          }
        },
        {
          "@type": "Question",
          "name": "Я собираюсь вернуть неиспользованный билет, на что обратить внимание?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Формирование запроса на возврат Билета  Возврат Билета производится круглосуточно через функционал Сайта. Возможно производить возврат одного или нескольких Билетов в Заказе.  Для возврата неиспользованного Билета необходимо пройти в раздел «Возврат билета», авторизоваться посредством указания электронного адреса или телефона, указанного во время оформления Билета и следовать дальнейшим инструкциям.  Возврат платежей по Билетам, приобретенным по платежным картам, производится на банковский карт-счет, с которого производилась оплата, в течение 5 (пяти) рабочих дней с момента получения подтверждения возврата Билета.  При оформлении возврата билета, сумма, уплаченная за Дополнительные услуги, возврату не подлежит.  Порядок удержания сумм при возврате Билета  За неиспользованные Билеты и несостоявшуюся вследствие этого перевозку багажа Перевозчик возвращает Пассажиру деньги в следующих случаях:  · не позднее, чем за 24 часа до отправления поезда - полную стоимость проезда;  · менее чем за 24 часа, но не позднее, чем за 6 (шесть) часов до отправления поезда - стоимость билета и 50 % (пятидесяти) стоимости плацкарты;  · менее чем за 6 часов до отправления и не более 1 (одного) часа после отправления поезда - стоимость билета, при этом удерживается вся стоимость плацкарты, но не более 30% от стоимости проезда.  По истечении 1 (одного) часа после отправления поезда возврат Билета не производится, денежные средства не возвращаются."
          }
        }
      ]
    }`
